import { connect } from 'react-redux';
import { getTypes, getInputDataToSend } from '../../../../store/form/selectors';
import { setInputDataToSend } from '../../../../store/form/actions';
import TypeSection from './TypeSection';
import { getLoader } from '../../../../store/loader/selectors';

const mapStateToProps = (state) => ({
  loader: getLoader(state),
  types: getTypes(state),
  inputData: getInputDataToSend(state),
});

const mapDispatchToProps = (dispatch) => ({
  setInputDataToSend: (key, data) => {
    dispatch(setInputDataToSend(key, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TypeSection);
